import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './style.css'
import * as actions from '../../actions/search'

export const mapStateToProps = (state, ownProps) => {
  return {
    pagination: state.diamondSearch.pagination || {total_hits: 0, current_page: 0, hits_per_page: 0}
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeFilterVal: (data) => {
      dispatch(actions.setPageSizeAndSearch(data.target.value))
    }
  }
}

export const currentPageLowerIndex = (totalHits, currentPage, hitsPerPage) => {
  if (totalHits === 0) {
    return 0
  }
  return currentPage * hitsPerPage + 1
}

export const currentPageUpperIndex = (totalHits, currentPage, hitsPerPage) => {
  if (totalHits === 0) {
    return 0
  }
  // when the qty of items on the last page < hitsPerPage, return totalHits as the upper index
  if (totalHits - currentPageLowerIndex(totalHits, currentPage, hitsPerPage) < hitsPerPage) {
    return totalHits
  }
  return currentPageLowerIndex(totalHits, currentPage, hitsPerPage) + hitsPerPage - 1
}

export class PaginationInfo extends Component {
  render () {
    const props = this.props
    const { total_hits, current_page, hits_per_page } = props.pagination
    return (
      <div className={css.paginationInfo}>
        Showing {currentPageLowerIndex(total_hits, current_page, hits_per_page)}-{currentPageUpperIndex(total_hits, current_page, hits_per_page)} of {props.resultsTrueTotal} · Items per page:
        <select id='hits_per_page' value={hits_per_page} onChange={props.onChangeFilterVal.bind(this)} className={css.plain} >
          <option value='25'>25</option>
          <option value='50'>50</option>
          <option value='100'>100</option>
          <option value='250'>250</option>
        </select>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginationInfo)



// WEBPACK FOOTER //
// ./src/components/search-results/pagination-info.js